import React, { useEffect, useState } from 'react';

/**
 * Floating "back to top" control for long pages. Sits above the WhatsApp
 * button in the site layout so the two never overlap, and only appears once
 * there is enough scrolled distance to make it useful.
 */
const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      className={`fixed right-5 bottom-24 z-40 w-11 h-11 rounded-full border border-surface-border bg-surface-card text-muted shadow-lg flex items-center justify-center transition-all duration-300 hover:text-primary-500 hover:border-primary-500/40 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
      </svg>
    </button>
  );
};

export default BackToTop;
